module.exports = __webpack_public_path__ + "img/PY.7b85c6b3.webp";